interface MainHeroProps {
  children: React.ReactNode
}

export const MainHero: React.FC<MainHeroProps> = ({ children }) => {
  return (
    <section className='relative'>
      <div className='gradient-circle top-[-500px] left-[400px] w-[1500px] h-[1500px]'></div>
      <div className='gradient-circle top-0 left-[-400px] w-[1500px] h-[1500px]'></div>
      <div className='container container-1200'>
        { children }
      </div>
    </section>
  )
}
